(function (app) {

    app.value("eventDays", [
        {
            Date: "April 11, 2019",
            Title: "Day 1",
            Timeline: [
                {
                    Time: "12:00PM",
                    Title: "Arrive at FIG / Check In / Lunch",
                    Description: ""
                },
                {
                    Time: "1:00PM",
                    Title: "Introductions and Meeting Purpose",
                    Description: "Our Chief Operating Officer, Brian Williams, will kick off this exciting  meeting with introductions as well as what we will dive into over the course of the next 2 days."
                },
                {
                    Time: "1:30PM",
                    Title: "Sales Team Process",
                    Description: "We will walk through the different tools our sales team uses as well as those available to our agents to use."
                },
                {
                    Time: "2:45PM",
                    Title: "Break",
                    Description: ""
                },
                {
                    Time: "3:00PM",
                    Title: "Marketing Processes and Tools",
                    Description: "See how our marketing team works directly with agents and vendors to create and execute marketing plans."
                },
                {
                    Time: "4:00PM",
                    Title: "FIG’s Tech Team: Structure, Architecture, and Infrastructure",
                    Description: "Learn a detailed breakdown of how our Tech Team develops. We will go over our team breakdown and methodologies used. Lastly, our own Software Architect will walk you through the history of the team's architecture and where we are today."
                },
                {
                    Time: "4:45PM",
                    Title: "Break",
                    Description: ""
                },
                {
                    Time: "5:00PM",
                    Title: "Contracting and Commissions",
                    Description: "We will walk through our contracting and commissions processes. This will include a demonstration of the different touchpoints we have with 3rd party programs as well as what is automated vs what is still manual."
                },
                {
                    Time: "6:30PM",
                    Title: "Dinner at The Peninsula Club",
                    Description: "Come dine with us at The Peninsula Club on Lake Norman."
                }
            ]
        },
        {
            Date: "April 12, 2019",
            Title: "Day 2",
            Timeline: [
                {
                    Time: "8:30AM",
                    Title: "Breakfast and Intro to Day 2",
                    Description: ""
                },
                {
                    Time: "9:00AM",
                    Title: "New Business Workflows and Data Integration ",
                    Description: "Explore how our New Business department handles processing applications and follow ups. How e-apps fit into that workflow and where data fits into the mix."
                },
                {
                    Time: "10:00AM",
                    Title: "Break",
                    Description: ""
                },
                {
                    Time: "10:15AM",
                    Title: "Future Priorities, Takeaways, and Touch on Outside Companies",
                    Description: ""
                },
                {
                    Time: "11:30AM",
                    Title: "Wrap Up",
                    Description: ""
                },
                {
                    Time: "12:00PM",
                    Title: "Depart from FIG",
                    Description: ""
                }
            ]
        }
    ]);

})(window.app, window.angular); //jshint ignore:line